// Grade Guide copy. Only grades and products listed on the Products page are recommended.
const uses = {
  eyebrow: 'Grade guide',
  title: 'Which cinnamon for which job',
  intro: 'Most people who get in touch know what they want to make, not which grade they need. This page matches the two — and covers storing it, cooking with it, and what to send us when you’re ready for a quote.',

  guide: {
    eyebrow: 'Quick guide',
    title: 'Start with what you’re making',
    tableLabel: 'Recommended grades by use',
    columns: ['If you’re making…', 'We’d suggest', 'Why'],
    rows: [
      { use: 'Whole sticks for retail, gifting and cafés', grades: ['C5', 'C4'], why: 'The thinnest, palest quills we sell. They look even on a shelf, snap cleanly and have the most delicate flavour.' },
      { use: 'Tea, coffee, mulled wine and syrups', grades: ['C4', 'C5', 'Quillings'], why: 'Quills infuse slowly and can be lifted out. If the drink is strained anyway, quillings give the same flavour for less.' },
      { use: 'Ground cinnamon, bakeries and spice blends', grades: ['H1', 'H2', 'H3', 'Quillings'], why: 'Once it is ground, nobody sees the quill size. Hamburg grades and quillings put your money into flavour, not appearance.' },
      { use: 'Industrial milling and extraction', grades: ['Off cuts', 'H3', 'Quillings'], why: 'The most economical bark per kilo. Pieces vary in size, which doesn’t matter when everything goes into a mill or still.' },
      { use: 'Fragrance, cosmetics and candles', grades: ['Cinnamon oil'], why: 'Leaf oil and bark oil smell quite different. Tell us what the oil is going into and we’ll advise which one fits.' },
    ],
    // Sentence split around the link to the products page
    note: {
      before: 'Diameters and photos of each grade are on the ',
      link: 'products page',
      after: '. Not sure? Describe what you’re making and we’ll recommend a grade.',
    },
  },

  forms: {
    eyebrow: 'What we sell',
    title: 'Quills, pieces and oil',
    caption: 'The end of a quill: dozens of paper-thin layers rolled together.',
    items: [
      { name: 'Quills', text: 'Inner bark peeled, rolled by hand and packed with smaller pieces into long tubes. Graded by diameter — the thinner the quill, the higher the grade.' },
      { name: 'Quillings', text: 'Broken pieces of quill from every grade. Same bark, same flavour, irregular shape. The usual choice for grinding.' },
      { name: 'Off cuts', text: 'The trimmed ends left after quills are cut to length. Sold by weight in 5 kg and 10 kg boxes.' },
      { name: 'Ground cinnamon', text: 'Best ground close to when it is used — the aroma fades much faster once the bark is powdered.' },
      { name: 'Leaf oil and bark oil', text: 'Leaf oil is mostly eugenol, with a clove-like warmth. Bark oil is mostly cinnamaldehyde — the familiar cinnamon smell — and costs considerably more.' },
    ],
  },

  kitchen: {
    eyebrow: 'In the kitchen',
    title: 'Cooking with Ceylon cinnamon',
    tips: [
      { title: 'Use a little more than the recipe says', text: 'Most recipes are written for cassia, which is sharper. With Ceylon cinnamon, start with the stated amount and add to taste.' },
      { title: 'One quill is roughly half a teaspoon', text: 'A 7–8 cm piece of quill gives about the same flavour as ½ teaspoon of ground cinnamon.' },
      { title: 'Simmer, don’t boil hard', text: 'For tea or milk, simmer a broken quill for 10–15 minutes. Long hard boiling drives off the lighter aromas.' },
      { title: 'Grind your own', text: 'Snap quills into short pieces and run them through a spice or coffee grinder, then sift. Fresh powder smells noticeably sweeter.' },
    ],
  },

  storage: {
    eyebrow: 'Storage',
    title: 'Keeping it fresh',
    items: [
      'Keep it airtight, in a cool, dark cupboard — not beside the stove.',
      'Whole quills hold their flavour for two to three years. Ground cinnamon is best within six months.',
      'Check it by snapping a piece: good cinnamon smells sweet and strong straight away.',
      'For bulk stock, keep cartons off the floor and away from damp walls. Moisture is the main thing that spoils cinnamon.',
    ],
  },

  faq: {
    eyebrow: 'Questions',
    title: 'Things people ask us',
    items: [
      { q: 'Is the cinnamon sold in supermarkets the same thing?', a: 'Often not. Much of what is sold simply as “cinnamon” is cassia, a related but different bark. Ceylon cinnamon has thin, papery layers and a milder, sweeter taste.', link: { to: '/true-cinnamon', label: 'How to tell them apart' } },
      { q: 'Why does Ceylon cinnamon taste milder?', a: 'It has less of the sharp, hot edge that cassia has, and more of the floral and citrus notes. That makes it easier to use generously in drinks and desserts.' },
      { q: 'Which grade do most food manufacturers buy?', a: 'For anything that is ground or blended, Hamburg grades or quillings. The higher grades are worth it when the stick itself is on show.' },
      { q: 'Can I see the cinnamon before placing a full order?', a: 'Yes. We send samples on request; sample shipping is charged at cost.', link: { to: '/how-we-work', label: 'How ordering works' } },
    ],
  },

  quote: {
    eyebrow: 'Ordering',
    title: 'What to include when you ask for a quote',
    items: [
      'The grade, or what the cinnamon will be used for',
      'Quantity, and whether it’s a one-off or regular order',
      'Packaging — bulk cartons, retail packs, or private label',
      'Destination port and preferred shipping terms (EXW, FOB, CIF…)',
      'Any documents you need, and whether you’d like samples first',
    ],
    primary: 'Request a quote',
    secondary: 'How ordering works',
  },
};

export default uses;
